import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,

    state: {
        payment: {
            Reason: null,
            Amount: null,
            FirstName: null,
            Surname: null,
            AddressLine1: null,
            AddressLine2: null,
            Town: null,
            Postcode: null,
        },
    },

    getters: {
        getField,
    },

    actions: {
        submit({ state }, data) {
            return axios.post('/api/contacts/pay', {
                ...state.payment,
                RowPK: data.rowPK,
                Path: data.path,
            });
        },
    },

    mutations: {
        updateField,
    },
};
